import { addMessages } from '../../store/conversation/actions';
import store from '../../store'

export default function atendenteEnviaMenssagem(event) {
    store.dispatch(addMessages(event));
}